<template>
  <div class="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-100 dark:border-gray-800 p-6">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-6">Documentation</h1>
    
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      <!-- Getting Started -->
      <div>
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">Getting Started</h2>
        <ul class="space-y-2">
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Quick Start Guide</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">System Requirements</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Installation Guide</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Basic Configuration</a>
          </li>
        </ul>
      </div>

      <!-- Features -->
      <div>
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">Features</h2>
        <ul class="space-y-2">
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Point of Sale</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Inventory Management</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Customer Management</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Reporting & Analytics</a>
          </li>
        </ul>
      </div>

      <!-- API Reference -->
      <div>
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">API Reference</h2>
        <ul class="space-y-2">
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">REST API Overview</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Authentication</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Endpoints</a>
          </li>
          <li>
            <a href="#" class="text-blue-600 dark:text-blue-400 hover:underline">Error Handling</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Search Documentation -->
    <div class="mt-8 p-6 bg-gray-50 dark:bg-gray-800 rounded-lg">
      <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">Search Documentation</h2>
      <div class="flex gap-4">
        <input
          type="search"
          placeholder="Search documentation..."
          class="flex-1 px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900"
        />
        <button
          class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Search
        </button>
      </div>
    </div>
  </div>
</template>